import React from "react";
import { MainLayout } from "../../MainLayout";
import { UgandaSec1Data } from "../../../Data/IndiaSec1Data";
import { Footer } from "../../Footer";
import { IndiaSec4 } from "../India/IndiaSec4/IndiaSec4";
import { IndiaSec1 } from "../India/IndiaSec1/IndiaSec1";
import { IndiaSec2 } from "../India/IndiaSec2/IndiaSec2";
import { IndiaSec3 } from "../India/IndiaSec3/IndiaSec3";
export const Uganda = () => {

    const destinationPackages = [
        {
            mapImg: "/assets/uganda-air.png",
            sliderimg: [
                {
                    id: 1,
                    img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/gorilla.webp",
                    title: "Gorilla Trekking ",
                },
                {
                    id: 2,
                    img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/nile.webp",
                    title: "Nile Uganda",
                },
            ],
            title: "2N/3D Chimpanzee Trekking Escape",
            subtitle: "Primate Encounters & Lush Rainforests",
            days: "2N/3D",
            tags: ["WildLife", "Boat House", "WaterFall"],
            description: `This 3-day chimpanzee tracking safari in Kibale Forest offers an immersive wildlife experience in Uganda. The journey in Kampala includes a guided walk in Bigodi Wetland Sanctuary and a visit to the scenic "Top of the World" viewpoint. The highlight is chimpanzee tracking in Kibale National Park, home to diverse primates and rich birdlife. The trip concludes with a cultural visit to Fort Portal and the historic Tooro Palace before returning to Kampala.`,
            img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/CimpangeTracking.webp",
            slug: "chimpanjeeTracking",
        },

        {
            title: "2N/3D Gorilla Kingdom",
            subtitle: "Close Encounters with Gentle Giants",
            days: "2N/3D",
            tags: ["WildLife", "Safari", "WaterFall"],
            description:
                "The 3-Day Gorilla Trekking Safari in Bwindi Impenetrable National Park offers an immersive experience in Uganda's dense rainforest. The journey begins in Kampala, with a drive to Bwindi for a thrilling gorilla trekking adventure. Visitors also explore the Batwa community, learning about their traditional way of life. The itinerary includes a stop at the scenic Lake Bunyonyi for canoeing and relaxation before returning to Kampala, making it a perfect blend of wildlife, culture, and nature.",
            img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/chim.webp",
            slug: "gorillaTreking",
        },

        {
            title: "2N/3D Mighty Falls Safari",
            subtitle: "Rushing Waters & Big Game Safari",
            days: "2N/3D",
            tags: ["WildLife", "Safari", "Sightseeing"],
            description:
                "The 3-Day Safari Package to Murchison Falls National Park offers an exciting wildlife adventure in Uganda’s largest national park. Starting from Kampala, the journey includes rhino tracking at Ziwa Rhino Sanctuary, game drives, and a boat safari along the Nile to witness the dramatic Murchison Falls. Visitors stay at Pakuba Safari Lodge, located within the park for a close-to-nature experience. The trip concludes with a scenic stop at the Top of the Falls before returning to Kampala.",
            img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/uganda3.webp",
            slug: "murchinsonFalls",
        },

        {
            title: "2N/3D Queen’s Safari",
            subtitle: "Diverse Wildlife & River Safari",
            days: "2N/3D",
            tags: ["WildLife", "Bird Haven", "WaterFall"],
            description:
                "The 3-day safari to Queen Elizabeth National Park offers an exciting wildlife experience in Uganda. It includes thrilling game drives to spot elephants, lions, and buffalo, along with a boat safari on the Kazinga Channel to see hippos and crocodiles. Guests stay at Buffalo Safari Lodge and visit the Equator for a memorable photo stop. The journey showcases breathtaking landscapes and diverse wildlife encounters. The trip concludes with a return to Kampala.",
            img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/queensafari.webp",
            slug: "queenElizabeth",
        },

        {
            title: "3N/4D Wild Frontier",
            subtitle: "Remote Safaris & Cultural Heritage",
            days: "3N/4D",
            tags: ["WildLife", "Safari", "Sightseeing"],
            description:
                "This 4-day safari to Kidepo Valley National Park begins with a scenic drive from Kampala to Moroto, where guests experience the culture of the Karamojong people. The journey continues to Kidepo Valley for thrilling game drives, breathtaking landscapes, and abundant wildlife, including elephants, buffalo, and lions. Guests will also visit the Manyatta community to learn about local traditions before returning to Kampala via Gulu. This adventure blends wildlife exploration with rich cultural experiences for an unforgettable safari.",
            img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/wild.webp",
            slug: "kidepoCulture",
        },

        {
            title: "3N/4D Gorilla & Golden Monkey Trail",
            subtitle: "Primate Safari & Scenic Trails",
            days: "3N/4D",
            tags: ["WildLife", "Safari", "Sightseeing"],
            description:
                "This 4-day safari takes you through Uganda's breathtaking Bwindi Impenetrable National Park and Kisoro, offering an unforgettable wildlife experience. You'll embark on thrilling mountain gorilla trekking, golden monkey tracking, and a cultural Batwa Trail experience. Accommodations include Gorilla Leisure Lodge and Ichumbi Hotel, ensuring comfort throughout your adventure. The journey starts and ends in Kampala, with scenic drives, guided safaris, and immersive encounters with Uganda’s rich biodiversity.",
            img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/Golden-Monkey.webp",
            slug: "goldenMonketTrekking",
        },

        {
            title: "4N/5D Gorilla & Wildlife Odyssey",
            subtitle: "Jungle Adventures & Wildlife Encounters",
            days: "4N/5D",
            tags: ["WildLife", "Safari", "Bird Haven"],
            description:
                "This 5-day safari takes you on an unforgettable adventure through Uganda’s breathtaking landscapes, starting and ending in Kampala. You’ll trek to rare mountain gorillas in Bwindi Impenetrable National Park, enjoy serene canoeing on Lake Bunyonyi, and experience thrilling wildlife encounters in Lake Mburo National Park, including an evening game drive and a walking safari. Cultural highlights include a visit to the Batwa community and Igongo Cultural Centre, with comfortable lodge accommodations and full-board meals throughout the journey.",
            img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/wildlife.webp",
            slug: "mburoNationalPark",
        },

        {
            title: "5N/6D Pearl of Africa Safari",
            subtitle: "Iconic Parks & Rich Traditions",
            days: "5N/6D",
            tags: ["WildLife", "Safari", "Bird Haven"],
            description:
                "This 6-day safari takes you on an incredible journey through Uganda’s most scenic and wildlife-rich parks, starting in Kampala. You'll explore the rugged landscapes of Kidepo Valley National Park, encounter diverse wildlife on game drives, and experience the culture of the Karamojong people. In Murchison Falls National Park, enjoy a boat safari on the Nile, witness the powerful falls, and spot elephants, lions, and giraffes. The adventure ends with a visit to the top of the falls before returning to Kampala.",
            img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/pearl.webp",
            slug: "kidepoValley",
        },
    ];

    const topcitydata = [
        {
            id: 1, title: "Kampala", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Kampala%20Uganda.webp", desc: [
                <p><strong>Why Visit: </strong>As the capital and largest city of Uganda, Kampala is a bustling urban center that mixes modern development with traditional culture. It’s a vibrant city with a rich history, cultural attractions, and a lively nightlife.</p>,
                <p><strong>Top Attractions: </strong>Gaddafi National Mosque, Uganda Museum, Baha'i Temple, Kasubi Tombs (UNESCO World Heritage site), Lake Victoria (enjoy the lakeside parks and activities), and Nakasero Market.</p>
            ]
        },
        {
            id: 2, title: "Entebbe", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Entebbe%20Uganda.webp", desc: [
                <p><strong>Why Visit: </strong>Entebbe is located on the shores of Lake Victoria and is home to Uganda’s international airport. It’s known for its natural beauty, with lush gardens and peaceful lakeside views, making it a great place to relax.</p>,
                <p><strong>Top Attractions: </strong>Entebbe Zoo, Ngamba Island Chimpanzee Sanctuary, Lake Victoria Beaches, Botanical Gardens, and Mabamba Swamp (for birdwatching).</p>
            ]
        },
        {
            id: 3, title: "Jinja", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Jinja%20Uganda.webp", desc: [
                <p><strong>Why Visit: </strong>Jinja, located on the shores of Lake Victoria, is considered the adventure capital of Uganda. It’s famous for the Source of the Nile, where the river begins its journey to Egypt, and offers plenty of outdoor activities like white-water rafting and boat cruises.</p>,
                <p><strong>Top Attractions: </strong>Source of the Nile, Bujagali Falls, Itanda Falls, White Water Rafting on the Nile, and Jinja Market.</p>
            ]
        },
        {
            id: 4, title: "Fort Portal", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Fort%20Portal%20Uganda.webp", desc: [
                <p><strong>Why Visit: </strong>Fort Portal is a picturesque town located in western Uganda, close to the Rwenzori Mountains and numerous national parks. It’s a gateway to exploring Uganda's natural beauty and wildlife.</p>,
                <p><strong>Top Attractions: </strong>Semuliki National Park, Rwenzori Mountains National Park, Lake Kyoga, Fort Portal Crater Lakes, and Kibale National Park (home to chimpanzees).</p>
            ]
        },
        {
            id: 5, title: "Mbarara", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Mbarara%20Uganda.webp", desc: [
                <p><strong>Why Visit: </strong>Mbarara is a major town in southwestern Uganda, serving as a gateway to the western Uganda national parks. It is known for its scenic landscapes and is an excellent spot for experiencing local culture and wildlife.</p>,
                <p><strong>Top Attractions: </strong>Lake Mburo National Park, Igongo Cultural Centre, and Mbarara City Market.</p>
            ]
        },
        {
            id: 6, title: "Kabale", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Kabable%20Uganda.webp", desc: [
                <p><strong>Why Visit: </strong>Kabale is a charming town in southwestern Uganda, surrounded by rolling hills and lakes. It’s often referred to as the “Switzerland of Africa” due to its mountainous landscape and stunning views.</p>,
                <p><strong>Top Attractions: </strong>Lake Bunyonyi (one of the deepest lakes in Africa), Bwindi Impenetrable Forest (home to mountain gorillas), and Mgahinga Gorilla National Park.</p>
            ]
        },
        {
            id: 7, title: "Masaka", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Masaka%20Uganda.webp", desc: [
                <p><strong>Why Visit: </strong>Located in the southern part of Uganda, Masaka is a small but vibrant city known for its agricultural significance. It's also a great base for exploring the nearby Lake Mburo National Park and other natural attractions.</p>,
                <p><strong>Top Attractions: </strong>- Top attractions: Lake Nabugabo, Lake Mburo National Park, and nearby cultural sites.</p>
            ]
        },
        {
            id: 8, title: "Gulu", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Gulu%20Uganda.webp", desc: [
                <p><strong>Why Visit: </strong>Gulu is a city in northern Uganda that has been historically significant and is now developing rapidly. It offers insight into Uganda's modern history, especially during and after the civil conflict, and is close to wildlife and cultural sites.</p>,
                <p><strong>Top Attractions: </strong>Murchison Falls National Park (easily accessible from Gulu), Acholi Cultural Sites, and Gulu Town Markets.</p>
            ]
        },
        {
            id: 9, title: "Kidepo Valley National Park", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Uganda%20Top%20places/Uganda%20Top%20places/Kidepo%20valley%20national%20Park.webp", desc: [
                <p><strong>Why Visit: </strong>Although not a city, Kidepo Valley National Park is one of the most remote but spectacular parks in Uganda, located in the northeastern part of the country. It’s one of the best places in Uganda for wildlife viewing, including lions, elephants, and giraffes.</p>,
                <p><strong>Top Attractions: </strong>Kidepo Valley National Park, Narus Valley, and Kanangorok Hot Springs.</p>
            ]
        },
        {
            id: 10, title: "Sembabule", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Uganda%20Top%20places/Uganda%20Top%20places/Sembabule.webp", desc: [
                <p><strong>Why Visit: </strong>Sembabule is a small town in central Uganda, known for its agricultural activities, particularly cattle farming. The region is great for experiencing rural Ugandan life, traditional music, and dance.</p>,
                <p><strong>Top Attractions: </strong>Local cultural sites, Nakasongola (nearby for nature lovers), and visits to traditional cattle farms.</p>
            ]
        },
        {
            id: 11, title: "Kampala’s Surrounding Areas", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Kampalal%20Surrounding%20area.webp", desc: [
                <p><strong>Why Visit: </strong>Beyond the city itself, the areas surrounding Kampala are rich in cultural and natural attractions. You can take day trips to explore local villages, lakes, and national parks.</p>,
                <p><strong>Top Attractions: </strong>Lake Victoria, Entebbe Botanic Gardens, and Zika Forest.</p>
            ]
        },
        {
            id: 12, title: "Sipi Falls", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Sipi%20Falls%20Uganda.webp", desc: [
                <p><strong>Why Visit: </strong>While not a city, Sipi Falls in eastern Uganda is a spectacular natural attraction located near Mount Elgon National Park. It’s known for its stunning waterfalls and is a popular spot for hiking, birdwatching, and photography.</p>,
                <p><strong>Top Attractions: </strong>Sipi Falls, Mount Elgon National Park, and Cultural tours in the Sipi region.</p>
            ]
        }
    ];

    const data = [
        {
            id: 1,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon1.png",
            title: "Custom Uganda Itineraries",
            desc: "Design well-paced journeys combining gorilla trekking, wildlife safaris, and cultural regions, structured to manage travel time efficiently across diverse landscapes."
        },
        {
            id: 2,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon2.png",
            title: "Chimpanzee Tracking Add-Ons",
            desc: "Include chimpanzee tracking in Kibale Forest to complement gorilla experiences, ideal for clients seeking primate-focused journeys."
        },
        {
            id: 3,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon3.png",
            title: "Gorilla Trekking Experiences",
            desc: "Secure permits for Bwindi Impenetrable National Park with guided treks led by experienced trackers, making this a high-value, pre-planned experience."
        },
        {
            id: 4,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon4.png",
            title: "Wildlife Safari Programs",
            desc: "Build safari circuits across Queen Elizabeth National Park and Murchison Falls National Park with game drives, boat safaris, and diverse wildlife viewing."
        },
        {
            id: 5,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon5.png",
            title: "Adventure & Nile Experiences",
            desc: "Integrate activities around the Nile River near Jinja, including rafting, boat rides, and soft adventure options suited for varied travelers."
        },
        {
            id: 6,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon6.png",
            title: "Lodge & Safari Stay Options",
            desc: "Offer a selection of lodges and camps across key regions, ranging from mid-range to premium stays, chosen for location, comfort, and service reliability."
        },
        {
            id: 7,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon7.png",
            title: "Cultural & Community Experiences",
            desc: "Include authentic village visits and cultural interactions that add depth to the journey, designed to be respectful, immersive, and meaningful."
        },
        {
            id: 8,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon8.png",
            title: "Road-Based Travel Planning",
            desc: "Structure itineraries with reliable vehicle support and experienced driver-guides, balancing comfort, distance, and overall experience flow."
        },
    ];

    return (
        <>
            <MainLayout bgImage={'url("https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Figma%20Images/Destination/uganda%20banner.webp")'}
                text2={"Uganda"}
                button={true} />
            <IndiaSec1 IndiaSec1Data={UgandaSec1Data} />
              <IndiaSec2 countryCode="UG" />
            <IndiaSec3 data={topcitydata} name={"Uganda"} />
            <IndiaSec4
                data={data}
                heading={"Discover What We Bring to Uganda "}
            />
            <Footer />

        </>
    )


};